import React, { createContext, use, useMemo } from 'react'

import { useCompanyContractCapabilities } from '#hooks/useCompanyContractCapabilities'

import type { ICompanyContractContext, IProps } from './interfaces'

const CompanyContractContext = createContext<ICompanyContractContext | null>(null)

export const CompanyContractProvider = ({ companyId, children }: IProps): React.JSX.Element => {
  const { allowedProducts, isProductEnabled, isLoading } = useCompanyContractCapabilities(companyId)

  const contextValue = useMemo(
    (): ICompanyContractContext => ({
      allowedProducts,
      isProductEnabled,
      isLoading,
    }),
    [allowedProducts, isProductEnabled, isLoading],
  )

  return <CompanyContractContext value={contextValue}>{children}</CompanyContractContext>
}

export function useCompanyContract(): ICompanyContractContext {
  const context = use(CompanyContractContext)
  if (!context) throw new Error('useCompanyContract must be used within a CompanyContractProvider')

  return context
}
